'use strict';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  createUpdateApplicant, getYtjInformation, createSaveApplication,
  getFetchApplication, getValidateEmail, getValidatePhone,
  getValidatePhoneWithCode, getValidateEmailWithCode, getAsiakastietoScoringData
} from '../../actions/application';
import { GetAuthenticationSession, createLoginToken } from '../../actions/login';
import * as affiliationTracking from '../utils/affiliationTracking';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button'
import MaskedInput from 'react-text-mask';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/styles';

import { FormControl, Select, MenuItem, InputLabel as MuiInputLabel, Container } from '@material-ui/core';

import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import IconAdd from '@material-ui/icons/Add';
import IconRemove from '@material-ui/icons/Remove';

import IconOk from '@material-ui/icons/Done';
import IconError from '@material-ui/icons/Error';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { GetFetchOfferForInvoiceFinancing } from '../../actions/loanOffer';
import Snack from '../utils/snack'
import CircularProgress from '@material-ui/core/CircularProgress';
import { GeneralFooter } from '../utils/generalFooter';
import ApplicationDetails from '../becomeApplicant/applicationDetails';

import OptionalAttachments from '../becomeApplicant/optionalAttachments';
import queryString from 'query-string'
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import Slider from '@material-ui/core/Slider';
import Collapse from '@material-ui/core/Collapse';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import checkmarkImage from '../../img/checkmark.svg';
import { COLOR_CENTER_BORDER } from '../../theme/tokens';
import hero from '../../Hero.webp';
import { trackLoanApplication, trackButtonClick, trackEvent } from '../../utils/gtm';

// Invoice financing specific constants
const maxInvoiceVolume = 500000; // Monthly invoice volume
const minInvoiceVolume = 5000;
const invoiceVolumeStep = 5000;
const maxPaymentTerms = 90; // Days
const minPaymentTerms = 15;
const paymentTermsStep = 15;
const maxFundingLimit = 1000000;
const minFundingLimit = 10000;
const fundingLimitStep = 5000;

// Factoring rates (daily rates)
const factorRateDaily = 0.000533; // 0.0533% per day (1.6% per month)

const styles = theme => ({
  checkmarkList: {
    textAlign: 'left',
    padding: 0,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    '& > li': {
      display: 'inline-block',
      '& > *': {
        display: 'inline-block',
        lineHeight: `${theme.spacing(3)}px`,
        verticalAlign: 'middle',
      },
      '&:not(:last-of-type)': {
        marginRight: '26px',
      },
      '&::before': {
        content: `url(${checkmarkImage})`,
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 10,
        height: `${theme.spacing(3)}px`,
      },
    },
  },
  calculatorMonthlyPaymentDetailBox: {
    padding: '2px !important',
    borderWidth: '1px 0 1px 1px',
    borderStyle: 'solid',
    borderColor: '#EBEBEA',
    padding: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      borderWidth: '1px 1px 0 1px',
      padding: theme.spacing(1),
      '&:last-of-type': {
        borderBottomWidth: '1px',
      },
    },
    '&:last-of-type': {
      borderRightWidth: '1px',
    },
  },
  calculatorSliderText: {
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '28px',
    letterSpacing: '0.01em',
  },
  calculatorNumber: {
    fontWeight: 500,
    fontSize: 22,
    lineHeight: '28px',
    letterSpacing: '-0.2px',
  },
});

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      prefix="$"
    />
  );
}

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

function getSimpleSteps() {
  return ['Rahoituksen perustiedot', 'Tunnistautuminen'];
}

const mapStateToProps = (state) => {
  return {
    application: state.application,
    offer: state.offer,
    authentication: state.auth
  };
};

const purposeStyle = {
  width: '200px',
  marginTop: '10px',
  fontSize: '10px'
}

const textStyle = {
  color: "black"
};
const iconStyle = {
  height: '15px'
}
const errorStyle = {
  color: 'red',
  marginTop: '20px'
}

const okStyle = {
  color: 'lightgreen',
  marginTop: '20px'
}


const mapDispatchToProps = (dispatch) => {
  return {

    updateApplication: (application) => dispatch(createUpdateApplicant(application)),
    getOffer: (loanAmt, loanLen, dueDate, capitalFreeMonths) => dispatch(GetFetchOfferForInvoiceFinancing(loanAmt, loanLen, dueDate, capitalFreeMonths)),
    getYtjInformation: (bic) => dispatch(getYtjInformation(bic)),
    getAuth: (id) => dispatch(GetAuthenticationSession(id)),
    saveApplication: (application) => dispatch(createSaveApplication(application)),
    fetchApplication: (application) => dispatch(getFetchApplication(application)),
    valEmail: (application) => dispatch(getValidateEmail(application)),
    valPhone: (application) => dispatch(getValidatePhone(application)),
    tryValEmailCode: (application) => dispatch(getValidateEmailWithCode(application)),
    tryValPhoneCode: (application) => dispatch(getValidatePhoneWithCode(application)),
    getScoringData: (application) => dispatch(getAsiakastietoScoringData(application)),
    createLoginToken: (serviceId, authenticationContext, applicationId) => dispatch(createLoginToken(serviceId, authenticationContext, applicationId)),

  };
};

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/]}
      
      keepCharPositions={false}
      showMask={false}
      InputLabelProps={{
        shrink: true,
      }}
      placeholderChar={'\u2000'}
    />
  );
}

function getSteps() {
  return ['Haettava laskurahoitus', 'Yrityksen tiedot', 'Yhteyshenkilön tiedot', 'Tunnistautuminen'];
}

function getStepContent(step) {
  switch (step) {
    case 0:
      return '';
    case 1:
      return '';
    case 2:
      return '';
    default:
      return '';
  }
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export function getGclidFromQuery(queryString) {
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('gclid');
}

export function getFbclidFromQuery(queryString) {
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get('fbclid');
}

class InvoiceFinancingProcess extends Component {
  getOfferDebounceHandler = null;
  processStartedEventFired = false; // Track if kr_process_started event has been fired (uses instance variable to avoid setState race conditions)
  
  // Store tracking values in instance variables to prevent them from being lost during state updates
  _trackingAffiliateBrowserId = '';
  _trackingGa4ClientId = '';
  _trackingGa4SessionId = '';

  constructor(props) {
    //For loan application type to update properly, we have to parse query string when state is initialized
    const values = queryString.parse(props.authUserId.params.id);
    const query = queryString.parse(props.search);

    let consolidation = 0;
    if (query.replace === '1' || values.replace === '1' || query.consolidation === 'true') {
      consolidation = 1;
    }
    
    super(props);
    this.state = {
      application: {
        invoiceVolume: 50000, // Monthly invoice volume
        paymentTerms: 45, // Average payment terms in days
        fundingLimit: 75000, // Requested funding limit
        capitalFreeMonths: 0,
        LoanPurposeTypeEnum: 0,
        LoanGuaranteeTypeEnum: 0,
        LoanDueDateTypeEnum: 0,
        freeMonthsToPaymentsCheck: false,
        ApplicationSource: "",
        bic: "",
        loanApplicationTypeEnum:consolidation,
        loanApplicationLoanTypeEnum: 5, // Invoice financing type
        affiliateCode: "",
        affiliate: "",
        affiliateBrowserId: "",
        ga4ClientId: "",
        ga4SessionId: "",
        factoringSourceEnum: 0, // Billing system enum
        factoringSourceDescription: "" // Custom description if not selected or other
      },
      activeStep: 0,
      validation: {
        amountError: false,
        lengthError: false,
        lastNameError: false,
        passwordAgainError: false,
        emailMissing: false,
      },
      isEmailValidationRequested: false,
      isEmailValidated: false,
      isPhoneValidationRequested: false,
      isPhoneValidated: false,
      isPasswordSet: false,
      isAuthenticated: false,
      canStep1forward: true,
      canStep2forward: false,
      canStep3forward: false,
      terms: false,
      creditCheck: false,
      defaultCheck: false,
      aiDecisionConsent: false,
      aiConsentRequired: false,
      completeEventSent: false,
      attachments: [],
      isUploading: false,
      isSavingAfterStep1: false,
      formInteractionStarted: false, // Track if user has started interacting with form
      calculatedResults: {
        immediateFunding: 45000,
        monthlyFactorFee: 1418,
        reserve: 5000,
        utilizationPercent: 60,
        dailyRate: '0.063',
        monthlyRate: '1.9',
        isLimitReached: false
      }
    };

    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleInvoiceVolumeChange = this.handleInvoiceVolumeChange.bind(this);
    this.handleInvoiceVolumeChangeSlider = this.handleInvoiceVolumeChangeSlider.bind(this);
    this.handlePaymentTermsChangeSlider = this.handlePaymentTermsChangeSlider.bind(this);
    this.handleFundingLimitChangeSlider = this.handleFundingLimitChangeSlider.bind(this);

    this.handlePaymentTermsChange = this.handlePaymentTermsChange.bind(this);
    this.validateEmailClick = this.validateEmailClick.bind(this);
    this.requestNewEmailVerificationClick = this.requestNewEmailVerificationClick.bind(this);
    this.handleEmailVerificationChange = this.handleEmailVerificationChange.bind(this);
    this.validatePhoneClick = this.validatePhoneClick.bind(this);
    this.requestNewPhoneVerificationClick = this.requestNewPhoneVerificationClick.bind(this);
    this.handlePhoneVerificationChange = this.handlePhoneVerificationChange.bind(this);
    this.handleLoanPurposeTypeEnumChange = this.handleLoanPurposeTypeEnumChange.bind(this);
    this.handleLoanDueDateTypeEnumChange = this.handleLoanDueDateTypeEnumChange.bind(this);
    this.authenticate = this.authenticate.bind(this);
    this.validatePasswordAgain = this.validatePasswordAgain.bind(this);
    this.incPaymentTerms = this.incPaymentTerms.bind(this);
    this.decPaymentTerms = this.decPaymentTerms.bind(this);
    this.incInvoiceVolume = this.incInvoiceVolume.bind(this);
    this.decInvoiceVolume = this.decInvoiceVolume.bind(this);
    this.incFundingLimit = this.incFundingLimit.bind(this);
    this.decFundingLimit = this.decFundingLimit.bind(this);
    this.validateFirstView = this.validateFirstView.bind(this);
    this.handleAttachmentsChange = this.handleAttachmentsChange.bind(this);
    this.handleFormInteractionStart = this.handleFormInteractionStart.bind(this);

  }

  // Handle form interaction start and trigger GTM event
  handleFormInteractionStart = () => {
    const storageKey = 'kr_process_started_invoice_funding_self';
    
    // Use instance variable to prevent race conditions AND localStorage to persist across page reloads
    if (!this.processStartedEventFired && !localStorage.getItem(storageKey)) {
      this.processStartedEventFired = true;
      localStorage.setItem(storageKey, 'true');
      this.setState({ formInteractionStarted: true });
      
      // Send GTM event for invoice financing form interaction started
      trackEvent('kr_process_started', {
        "process_name": "invoice_funding_self"
      }
      );
      
    }
  }

  incPaymentTerms = () => {
    let val = parseInt(this.state.application.paymentTerms);
    val = val + paymentTermsStep;
    if (val > maxPaymentTerms)
      val = maxPaymentTerms;
    this.setState({
      application: {
        ...this.state.application,
        paymentTerms: val
      }
    }, () => { this.calculateFactoring() });
  }
  decPaymentTerms = () => {
    let val = this.state.application.paymentTerms;
    val = val - paymentTermsStep;
    if (val < minPaymentTerms)
      val = minPaymentTerms;
    this.setState({
      application: {
        ...this.state.application,
        paymentTerms: val
      }
    }, () => { this.calculateFactoring() });
  }

  incFundingLimit = () => {
    let val = this.state.application.fundingLimit;
    val = val + fundingLimitStep;
    if (val > maxFundingLimit)
      val = maxFundingLimit;
    this.setState({
      application: {
        ...this.state.application,
        fundingLimit: val
      }
    }, () => { this.calculateFactoring() });
  }
  decFundingLimit = () => {
    let val = this.state.application.fundingLimit;
    val = val - fundingLimitStep;
    if (val < minFundingLimit)
      val = minFundingLimit;
    this.setState({
      application: {
        ...this.state.application,
        fundingLimit: val
      }
    }, () => { this.calculateFactoring() });
  }




  validateFirstView = async () => {
    // valid fields

    let email = this.state.application.email !== undefined && this.isEmailOk(this.state.application.email);
    let name = this.state.application.companyName !== undefined && this.state.application.companyName.length > 0
    let phone = this.state.application.phone !== undefined && this.isPhoneOk(this.state.application.phone);
    let bic = this.state.application.bic !== undefined && this.state.application.bic.length > 0;
    let check = this.state.defaultCheck;
    let aiConsent = this.state.aiDecisionConsent;
    this.setState({
      ...this.state,
      validation:
      {
        ...this.state.validation,
        emailError: !email,
        companyNameError: !name,
        phoneError: !phone,
        BICError: !bic,
      }
    }, () => {
      if (this.state.defaultCheck !== true)
        this.setState({
          ...this.state,
          defaultRequired: true
        })
      
      if (this.state.aiDecisionConsent !== true)
        this.setState({
          ...this.state,
          aiConsentRequired: true
        })
    });

    // Always save application after first step, regardless of validation status
    // This ensures consistent behavior with company loans
    this.setState({ isSavingAfterStep1: true });
    try {
      console.log("Saving invoice financing application after step 1 (basic info):", this.state.application);
      let appl = { ...this.state.application }
      
      // Get monthly payment from offer if available, otherwise use 0 as fallback
      const monthlyPayment = this.props.offer && this.props.offer.offerdata && this.props.offer.offerdata.loanDetails 
        ? this.props.offer.offerdata.loanDetails.monthlyPmt 
        : 0;
      
      // For invoice financing, set loanAmount to fundingLimit
      await this.props.saveApplication({ ...appl, monthlyPayment, loanAmount: this.state.application.fundingLimit });
      console.log("Invoice financing application saved successfully after step 1");
    } catch (error) {
      console.error("Error saving invoice financing application after step 1:", error);
      
      // Send GTM error event for backend failure

      trackEvent('kr_process_error', {
        "process_name": "invoice_funding_self",
        "error_message": error.message
      }
      );

      
      // Continue to next step even if save fails
    } finally {
      this.setState({ isSavingAfterStep1: false });
    }

    if (email && name && phone && bic && check && aiConsent) {
      // Validation passed, proceed to next step
      // Note: kr_process_completed will be sent when authentication is initiated
      
      this.handleNext();
    }

  }

  incInvoiceVolume = () => {
    let val = parseInt(this.state.application.invoiceVolume);
    val = val + invoiceVolumeStep;
    if (val > maxInvoiceVolume)
      val = maxInvoiceVolume;
    this.setState({
      application: {
        ...this.state.application,
        invoiceVolume: val
      }
    }, () => { this.calculateFactoring() });
  }

  decInvoiceVolume = () => {
    let val = this.state.application.invoiceVolume;
    val = val - invoiceVolumeStep;
    if (val < minInvoiceVolume)
      val = minInvoiceVolume;
    this.setState({
      application: {
        ...this.state.application,
        invoiceVolume: val
      }
    }, () => { this.calculateFactoring() });


  }

  handleAttachmentsChange = (attachments) => {
    this.setState({
      ...this.state,
      attachments: attachments
    });
  }

  authenticate = async () => {
    console.log("authenticate called, saving application with attachments first");
    console.log("current attachments state:", this.state.attachments);
    
    // Clear previous upload logs
    localStorage.removeItem('uploadLogs');
    
    // Show loading state
    this.setState({ ...this.state, isUploading: true });
    
    // Save the application with attachments before authentication
    let appl = { ...this.state.application }
    
    // Get monthly payment from offer if available, otherwise use 0 as fallback
    const monthlyPayment = this.props.offer && this.props.offer.offerdata && this.props.offer.offerdata.loanDetails 
      ? this.props.offer.offerdata.loanDetails.monthlyPmt 
      : 0;
    
    const applicationWithAttachments = { 
      ...appl, 
      monthlyPayment, 
      attachments: this.state.attachments 
    };
    
    console.log("saving application before authentication:", applicationWithAttachments);
    
    try {
      // Save application and wait for it to complete (including file uploads)
      const savedApplication = await this.props.saveApplication(applicationWithAttachments);
      console.log("application and attachments saved successfully, proceeding with authentication");
      
      // Send GTM event for invoice financing process completed (before authentication)
      // Only send if not already sent in handleNext
      if (!this.state.completeEventSent) {
        trackEvent('kr_process_completed', {
          "process_name": "invoice_funding_self",
          "value": this.state.application.fundingLimit,
          "application_id": savedApplication.id
        });
        this.setState({ completeEventSent: true });
      }
      
      // Clear the process started flag from localStorage since process is now complete
      localStorage.removeItem('kr_process_started_invoice_funding_self');

      // Hide loading state
      this.setState({ ...this.state, isUploading: false });
      
      // Add a small delay to ensure all uploads are complete
      setTimeout(() => {
        // Use createLoginToken which will handle getting the token and redirecting to NETS
        // serviceId 11 is for loan applications based on the original code
        this.props.createLoginToken(11, 4, savedApplication.id);
      }, 500);
      
    } catch (error) {
      console.error("Error saving application:", error);

      // Send GTM error event
      trackEvent('kr_process_error', {
        "process_name": "invoice_funding_self",
        "error_message": error.message || "Error saving application before authentication"
      });

      // Hide loading state
      this.setState({ ...this.state, isUploading: false });
      // Still proceed with authentication even if save fails, but only if we have an ID
      if (this.props.application.id) {
        setTimeout(() => {
          this.props.createLoginToken(11, 4, this.props.application.id);
        }, 500);
      } else {
        console.error("Cannot proceed with authentication: no application ID available");
      }
    }
  }

  validatePasswordAgain = () => {
    if (this.state.application.password !== this.state.application.passwordAgain) {
      this.setState({
        ...this.state,
        validation:
          { ...this.state.validation, passwordAgainError: true }
      })
    } else {
      this.setState({
        ...this.state,
        validation:
          { ...this.state.validation, passwordAgainError: false }
      })
    }
  }


  validateEmailClick = () => {
    this.setState({ ...this.state, isEmailValidationRequested: true });
    this.props.valEmail(this.state.application);
    //dispatch send code
    //add notification class to div      
  }

  requestNewEmailVerificationClick = () => {
    //dispatch resend code
  }

  handleEmailVerificationChange = (event) => {
    let val = event.target.value;
    //dispatch check code
  }

  handleTermsClick = (event) => {
    this.setState({ ...this.state, terms: event.target.checked })
  }


  handleDefaultCheckClick = (event) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let checked = event.target.checked;
    this.setState({ ...this.state, defaultCheck: checked }, () => {
      if (checked && this.state.defaultRequired)
        this.setState({ ...this.state, defaultRequired: false })
    })
  }

  handleAiDecisionConsentClick = (event) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let checked = event.target.checked;
    this.setState({ 
      ...this.state, 
      aiDecisionConsent: checked,
      aiConsentRequired: checked ? false : this.state.aiConsentRequired
    })
  }

  handleFactoringSourceChange = (event) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    const value = event.target.value;
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        factoringSourceEnum: value,
        // Clear description if not "NotSelected" (0)
        factoringSourceDescription: value !== 0 ? "" : this.state.application.factoringSourceDescription
      }
    });
  }

  handleFactoringSourceDescriptionChange = (event) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        factoringSourceDescription: event.target.value
      }
    });
  }

  handleApplicationTypeCheckClick = (event) => {
    let checked = event.target.checked;
    let val = 0;
    if (checked === true)
      val = 1;
    this.setState({
      application: {
        ...this.state.application,
        loanApplicationTypeEnum: val
      }
    }
    );
  }

  handlefreeMonthsToPaymentsCheckClick = (event) => {
    let checked = event.target.checked;
    let val = 0;
    if (checked === true)
      val = 1;

    if (val === 0) {
      this.setState({
        application: {
          ...this.state.application,
          freeMonthsToPaymentsCheck: val, capitalFreeMonths: 0
        }
      });
    }

    if (val === 1) {
      this.setState({
        application: {
          ...this.state.application,
          freeMonthsToPaymentsCheck: val, capitalFreeMonths: 1
        }
      });
    }

  }


  validatePhoneClick = () => {
    this.setState({ ...this.state, isPhoneValidationRequested: true });
    this.props.valPhone(this.state.application);

    //add notification class to div
    //dispatch send code
  }

  requestNewPhoneVerificationClick = () => {
    //dispatch resend code
  }

  handlePhoneVerificationChange = (event) => {
    let val = event.target.value;
    //dispatch check code
  }

  componentWillReceiveProps = (nextProps) => {

    if (nextProps.application.zip !== this.props.zip ||
      nextProps.application.contactDetails !== this.props.contactDetails ||
      nextProps.application.address !== this.props.address ||
      nextProps.application.id !== this.props.id) {
      this.setState({
        application:
        {
          ...this.state.application,
          ...nextProps.application,
          // ALWAYS use instance variables as source of truth (set once in componentDidMount)
          affiliateBrowserId: this._trackingAffiliateBrowserId || nextProps.application.affiliateBrowserId || '',
          ga4ClientId: this._trackingGa4ClientId || nextProps.application.ga4ClientId || '',
          ga4SessionId: this._trackingGa4SessionId || nextProps.application.ga4SessionId || ''
        }
      }, () => {/* // console.log(this.state) */ }
      )
    }

    if (nextProps.authentication
      && nextProps.authentication.isAuthenticated
      && nextProps.authentication.isAuthenticated === true) {
      this.setState({ ...this.state, activeStep: 4 },)
    }
  }


  handleInvoiceVolumeChange = (event) => {
    let val = parseInt(event.target.value) || minInvoiceVolume;
    
    if (val > maxInvoiceVolume) val = maxInvoiceVolume;
    if (val < minInvoiceVolume) val = minInvoiceVolume;

    this.setState({
      application: {
        ...this.state.application,
        invoiceVolume: val
      }
    }, () => { this.calculateFactoring() });
  };


  handlePaymentTermsChange = (event) => {
    let val = parseInt(event.target.value) || minPaymentTerms;
    
    if (val > maxPaymentTerms) val = maxPaymentTerms;
    if (val < minPaymentTerms) val = minPaymentTerms;

    this.setState({
      application: {
        ...this.state.application,
        paymentTerms: val
      }
    }, () => { this.calculateFactoring() });
  };


  handleFreeMonthsChange = (event, value) => {
    // Not used in invoice financing - stub function for compatibility
    let val = parseInt(value) || 0;
    this.setState({
      application: {
        ...this.state.application,
        capitalFreeMonths: val
      }
    });
  };


  handleInvoiceVolumeChangeSlider = (event, value) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let val = parseInt(value);
    this.setState({
      application: {
        ...this.state.application,
        invoiceVolume: val
      }
    }, () => { this.calculateFactoring() });
  };



  handlePaymentTermsChangeSlider = (event, value) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let val = parseInt(value);
    this.setState({
      application: {
        ...this.state.application,
        paymentTerms: val
      }
    }, () => { this.calculateFactoring() });
  };

  handleFundingLimitChangeSlider = (event, value) => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    let val = parseInt(value);
    this.setState({
      application: {
        ...this.state.application,
        fundingLimit: val
      }
    }, () => { this.calculateFactoring() });
  };





  // Calculate factoring terms and display results
  calculateFactoring = () => {
    const { invoiceVolume, paymentTerms, fundingLimit } = this.state.application;
    
    // Calculate immediate funding (90% of invoice volume, but limited by funding limit)
    const potentialFunding = Math.round(invoiceVolume * 0.9);
    const immediateFunding = Math.min(potentialFunding, fundingLimit);
    
    // Calculate factor fee (daily rate * payment terms * actual funded amount)
    const monthlyFactorFee = Math.round(immediateFunding * factorRateDaily * paymentTerms);
    
    // Calculate reserve (remaining amount after advance and fees)
    const reserve = Math.round(invoiceVolume - immediateFunding - monthlyFactorFee);
    
    // Calculate utilization percentage (how much of the limit is being used)
    const utilizationPercent = fundingLimit > 0 ? Math.round((immediateFunding / fundingLimit) * 100) : 0;
    
    // Store calculated values in state for display
    this.setState({
      calculatedResults: {
        immediateFunding,
        monthlyFactorFee,
        reserve,
        utilizationPercent,
        dailyRate: (factorRateDaily * 100).toFixed(3),
        monthlyRate: (factorRateDaily * 30 * 100).toFixed(1),
        isLimitReached: immediateFunding < potentialFunding
      }
    });
  }

  handleCbChange = name => (event, checked) => {
    this.setState({
      application: {
        ...this.state.application,
        [name]: checked
      }
    });
  };
  // validations



  isEmailOk = (val) => {
    this.setState({ validation: { ...this.state.validation, emailFormatError: false } });
    if (val === undefined || val === "") {
      return false;
    }
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailOk = re.test(val);

    return emailOk;
  }

  isPhoneOk = (val) => {
    return true;
  }

  validateEmail = () => {
    if (this.isEmailOk(this.state.application.email)) {
      this.setState({ validation: { ...this.state.validation, emailError: false } });
      return true;
    }
    else {
      this.setState({ validation: { ...this.state.validation, emailError: true } });
      return false;
    }
  }

  validatePhone = () => {
    if (this.isPhoneOk(this.state.application.phone)) {
      this.setState({ validation: { ...this.state.validation, phoneError: false } });
      return true;
    }
    else {
      this.setState({ validation: { ...this.state.validation, phoneError: true } });
      return false;
    }
  }
  isNumberOk = (val) => {
    return true;
  }

  handleNext = async () => {
    const { activeStep } = this.state;

    // Track with GTM
    // trackButtonClick('laskurahoitus_hakemus_nappi', 'invoice_financing_form');
    // trackLoanApplication('submit_invoice_financing', {
    //   invoice_volume: this.state.application.invoiceVolume,
    //   payment_terms: this.state.application.paymentTerms,
    //   funding_limit: this.state.application.fundingLimit,
    //   step: activeStep,
    //   loan_type: 'invoice_financing',
    //   loan_type_enum: 5
    // });

    this.props.updateApplication(this.state.application);

    // Note: Save logic moved to validateFirstView() to ensure consistent behavior
    // Application is now saved when "Avaa laskurahoitus" button is pressed

    if(!this.state.completeEventSent){

      const eventType = this.state.application.consolidation ? 'combine_loans' : 'invoice_funding_self';

      const value = this.state.application.consolidation ? this.state.application.loanAmount : this.state.application.fundingLimit;

      trackEvent('kr_process_completed', {
        "process_name": eventType,
        "value": value,
        "application_id": this.state.application.id || this.props.application?.id
      });
      
      // Clear the process started flag from localStorage since process is now complete
      localStorage.removeItem(`kr_process_started_${eventType}`);

      // trackEvent(eventType, {
      //   invoice_volume: this.state.application.invoiceVolume,
      //   payment_terms: this.state.application.paymentTerms,
      //   funding_limit: this.state.application.fundingLimit,
      //   step: activeStep,
      //   loan_type: 'invoice_financing',
      //   loan_type_enum: 5
      // });
      this.setState({ completeEventSent: true });
    }

    this.setState({ activeStep: activeStep + 1 });
   
  };

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };

  handleBicChange = name => event => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        [name]: event.target.value
      }
    }, () => { this.validateEmail() });
  };



  handleChange = (name, appl) => event => {
    this.handleFormInteractionStart(); // Trigger GTM event on first interaction
    
    // step0
    if (name === "email") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validateEmail() });
    }
    else if (name === "discountCode") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => {});
    }
    else if (name === "phone") {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validatePhone() });
    }
    else if (name === "bic") {
      
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      },
        () => {

          if (this.state.application.bic.length > 8) {
            this.props.getYtjInformation(this.state.application.bic);
            this.setState({
              ...this.state,
              validation:
              {
                ...this.state.validation,
                BICError: false
              }
            });

          }

        });

    }

    else if (name === "passwordAgain") {

      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          [name]: event.target.value
        }
      }, () => { this.validatePasswordAgain() });
    }

    else if (name === "emailCode") {
      let val = event.target.value;
      this.setState({ ...this.state, emailCode: val },
        () => {

          if (val.length >= 4) {
            this.setState({
              ...this.state,
              application: {
                ...this.state.application,
                [name]: val
              }
            }, () => {
              this.props.tryValEmailCode(this.state.application);
            });
          }

        });


    }

    else if (name === "phoneCode") {
      let val = event.target.value;

      this.setState({ ...this.state, phoneCode: val },
        () => {

          if (val.length >= 4) {
            this.setState({
              ...this.state,
              application: {
                ...this.state.application,
                [name]: val
              }
            }, () => {
              this.props.tryValPhoneCode(this.state.application);
            });
          }

        });

    }
    else this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        [name]: event.target.value
      }
    });
  }

  getStore() {
    return this.props.applicant;
  }
  isStepOptional = step => {
    // return step === 1;
    return false;
  };
  handleLoanPurposeTypeEnumChange = (event) => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanPurposeTypeEnum: event.target.value
      }
    });
  }

  handleLoanDueDateTypeEnumChange = (event) => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanDueDateTypeEnum: event.target.value
      }
    });

  }

  handleLoanGuaranteeTypeEnumChange = (event) => {
    this.setState({
      ...this.state,
      application: {
        ...this.state.application,
        LoanGuaranteeTypeEnum: event.target.value
      }
    });
  }

  componentDidMount = () => {
    const affiliationTrackingParams = affiliationTracking.retrieveParams();

    const values = queryString.parse(this.props.authUserId.params.id);
    const query = queryString.parse(this.props.search);
    let affiliateSrc = "";

    const affiliateCookie = getCookie('affiliation'); 

    let gclid = '';
    let fbclid = '';
    
    // Check for fbclid from _fbc cookie first (prioritized), then from saved affiliation cookie
    fbclid = affiliationTracking.getFacebookClickId() || '';
    
    if(affiliateCookie)
    {
        const affiliateData = JSON.parse(decodeURIComponent(affiliateCookie));
        gclid = getGclidFromQuery(affiliateData.query);
        
        // Only use fbclid from cookie if not already found from _fbc cookie
        if (!fbclid) {
          fbclid = getFbclidFromQuery(affiliateData.query);
        }
    }

    let consolidation = 0;
    
    if (query.replace === '1' || values.replace === '1' || query.consolidation === 'true') {
      consolidation = 1;
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          loanApplicationTypeEnum: consolidation,
        },
      });
    }

    if (values.sr !== undefined || query.sr !== undefined) {
      affiliateSrc = "Google Ads";
    }
    let affiliateCode = '';
    let affiliateBrowserId = '';
    let ga4ClientId = '';
    let ga4SessionId = '';
    
    // ALWAYS capture GA4 tracking data for all users (universal tracking)
    try {
      ga4ClientId = affiliationTracking.getGA4ClientId() || '';
      const ga4SessionData = affiliationTracking.getGA4SessionData();
      if (ga4SessionData && ga4SessionData.sessionId) {
        ga4SessionId = ga4SessionData.sessionId;
      }
    } catch (error) {
      console.warn('Could not extract GA4 data:', error);
    }
    
    // ALWAYS try to capture _fbp cookie value for Facebook Conversions API (even without fbclid)
    // This cookie persists and should be captured for all users who have visited from Facebook before
    const fbpCookieValue = affiliationTracking.getFacebookBrowserId();
    
    // Set affiliateBrowserId to _fbp by default if it exists (will be overridden for Google Ads traffic)
    if (fbpCookieValue) {
      affiliateBrowserId = fbpCookieValue;
    }
    
    // CRITICAL: Store tracking values in instance variables to survive state updates
    this._trackingAffiliateBrowserId = affiliateBrowserId;
    this._trackingGa4ClientId = ga4ClientId;
    this._trackingGa4SessionId = ga4SessionId;
    
    if(gclid)
    {
      affiliateCode = gclid;
      affiliateSrc = 'Google';

      // For Google: OVERRIDE affiliateBrowserId with GA4 Session ID (with error handling)
      try {
        const ga4SessionData = affiliationTracking.getGA4SessionData();
        if (ga4SessionData && ga4SessionData.sessionId) {
          affiliateBrowserId = ga4SessionData.sessionId;
        }
      } catch (error) {
        console.warn('Could not extract GA4 Session ID for Google:', error);
      }
    }
    if(fbclid)
    {
      affiliateCode = fbclid;
      affiliateSrc = 'Facebook';
      
      // For Facebook: affiliateBrowserId is already set to _fbp above
    }

    if (values.loanamount !== undefined && values.length !== undefined) {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          loanAmount: values.loanamount,
          affiliateCode: affiliateCode ? affiliateCode : values.sr,
          affiliate: affiliateSrc,
          affiliateBrowserId: affiliateBrowserId,
          ga4ClientId: ga4ClientId,
          ga4SessionId: ga4SessionId,
          loanLength: values.length,
          capitalFreeMonths: values.capitalfreemonths ? values.capitalfreemonths : 0,
          loanApplicationTypeEnum: consolidation,
        }
      });
      return;
    }

    if (affiliationTrackingParams && !gclid && !fbclid) {
        this.setState({
          ...this.state,
          application: {
            ...this.state.application,
            affiliate: affiliationTrackingParams.source,
            affiliateCode: affiliationTrackingParams.code,
            affiliateParams: affiliationTrackingParams.query,
            affiliateBrowserId: affiliationTrackingParams.browserId || '',
            ga4ClientId: affiliationTrackingParams.ga4ClientId || '',
            ga4SessionId: affiliationTrackingParams.ga4SessionId || ''
          }
        })
    }

    if(gclid || fbclid){
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          affiliate: affiliateSrc,
          affiliateCode: affiliateCode,
          affiliateBrowserId: affiliateBrowserId,
          ga4ClientId: ga4ClientId,
          ga4SessionId: ga4SessionId
        }
      })
    }
    
    // Fallback: Always ensure GA4 values AND _fbp are set even if no affiliate tracking conditions are met
    // This handles direct traffic, organic search, and other non-tracked sources
    if (!gclid && !fbclid && !affiliationTrackingParams && !(values.loanamount !== undefined && values.length !== undefined)) {
      this.setState({
        ...this.state,
        application: {
          ...this.state.application,
          affiliateBrowserId: affiliateBrowserId, // Include _fbp if it was captured
          ga4ClientId: ga4ClientId,
          ga4SessionId: ga4SessionId
        }
      })
    }

    // For invoice financing, we need to call the offer with invoice-specific parameters
    this.props.getOffer(this.state.application.invoiceVolume, this.state.application.paymentTerms, 0, this.state.application.capitalFreeMonths)
    
    // Initialize calculator
    this.calculateFactoring();

  }

  componentDidUpdate = (prevProps, prevState) => {
    const shouldUpdateLoanOffer = (prevState.application.loanAmount != this.state.application.loanAmount 
      || prevState.application.loanLength != this.state.application.loanLength 
      || prevState.application.capitalFreeMonths != this.state.application.capitalFreeMonths )

    if (JSON.stringify(prevState.application) !== JSON.stringify(this.state.application)) {  
      this.props.updateApplication(this.state.application);

      if (this.getOfferDebounceHandler) {
        clearTimeout(this.getOfferDebounceHandler);
      }
      this.getOfferDebounceHandler = setTimeout(() => {
        if(shouldUpdateLoanOffer){
          this.props.getOffer(this.state.application.loanAmount, this.state.application.loanLength, 0, this.state.application.capitalFreeMonths);
        }
      }, 200);
    }
  }


  render() {
    const steps = getSteps();
    const { activeStep } = this.state;
    const { classes } = this.props;

    const stepperSteps = [
      {
        title: 'Laskurahoituksen perustiedot',
        description: 'Määritä rahoituksen perustiedot ja ehdot',
        number: 1
      },
      {
        title: 'Lisätiedot ja liitteet',
        description: 'Laskutusjärjestelmä ja mahdolliset liitteet',
        number: 2
      },
      {
        title: 'Tunnistautuminen',
        description: 'Vahvista henkilöllisyytesi pankkitunnuksilla',
        number: 3
      }
    ];

    return (
      <Box style={{ color: "white" }}>
        
        {/* Subtle Stepper */}
        <Box style={{ 
          backgroundColor: '#f8f9fa',
          padding: '8px 20px',
          marginBottom: '12px',
          borderBottom: '1px solid #e9ecef'
        }}>
          <Container maxWidth="lg">
            <Box style={{ 
              display: 'flex', 
              justifyContent: 'center',
              alignItems: 'center',
              gap: '24px',
              flexWrap: 'wrap'
            }}>
              {stepperSteps.map((step, index) => (
                <Box key={index} style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  position: 'relative'
                }}>
                  {/* Connection Line */}
                  {index < stepperSteps.length - 1 && (
                    <Box style={{
                      position: 'absolute',
                      top: '50%',
                      left: '32px',
                      width: '24px',
                      height: '1px',
                      background: index < activeStep 
                        ? '#4CAF50' 
                        : '#dee2e6',
                      transform: 'translateY(-50%)',
                      zIndex: 0,
                      '@media (max-width: 960px)': { display: 'none' }
                    }} />
                  )}
                  
                  {/* Step Circle */}
                  <Box style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: index <= activeStep 
                      ? '#4CAF50'
                      : '#dee2e6',
                    color: index <= activeStep ? 'white' : '#6c757d',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    marginRight: '8px'
                  }}>
                    {index < activeStep ? '✓' : step.number}
                  </Box>
                  
                  {/* Step Content */}
                  <Typography variant="body2" style={{ 
                    color: index === activeStep ? '#333' : '#6c757d',
                    fontWeight: index === activeStep ? '600' : '400',
                    fontSize: '13px',
                    position: 'relative',
                    zIndex: 1
                  }}>
                    {step.title}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Container>
        </Box>

        <Hidden smDown>
          <div style={{ marginTop: "20px" }} />
        </Hidden>
        {this.props.application.isEmailValidated === true &&
          <Snack message={"Sähköpostiosoite " + this.state.application.email + " vahvistettu"} />
        }
        {this.state.isPhoneValidated === true &&
          <Snack message={"Matkapuhelinnumero " + this.state.application.phone + " vahvistettu"} />
        }

        <Grid container spacing={4}>

          {activeStep === 0 &&

            <Grid item xs={12}>

              {/* loan params */}
              <Grid container spacing={4}>
                <Grid item md={8}>

                  <Paper elevation={3} style={{ padding: "32px", height: '100%' }}>

                    <Hidden smDown>
                      <Typography variant='h3' style={{ marginBottom: '24px' }}>Avaa laskurahoitus</Typography>
                    </Hidden>

                    <Grid container direction='row' spacing={3} style={{ backgroundColor: '#fff', border: `1px solid ${COLOR_CENTER_BORDER}`, padding: '30px', textAlign: 'left', borderRadius: '12px', boxShadow: '0 8px 32px rgba(0,0,0,0.1)' }}>
                      <Grid item xs={12}>
                        <Grid container spacing={6}>
                          <Grid item xs={12} style={{ paddingBottom: 0 }}>
                            <Grid container alignItems="center" style={{ marginBottom: '8px' }}>
                              <Grid item xs={8}>
                                    <Typography className={classes.calculatorSliderText}>Kuukausittain rahoitettavat laskut</Typography>
                                  </Grid>
                              <Grid item xs={4}>
                                <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right', fontWeight: 'bold' }}>
                                  {this.state.application.invoiceVolume.toLocaleString('fi')}&nbsp;€
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Slider
                                  value={this.state.application.invoiceVolume}
                                  onChange={this.handleInvoiceVolumeChangeSlider}
                                  min={minInvoiceVolume}
                                  max={maxInvoiceVolume}
                                  step={invoiceVolumeStep}
                                />
                          </Grid>

                          <Grid item xs={12} md={6} style={{ paddingBottom: 0 }}>
                            <Grid container alignItems="center" style={{ marginBottom: '8px' }}>
                              <Grid item xs={8}>
                                <Typography className={classes.calculatorSliderText}>Rahoitettujen laskujen keskim. maksuaika</Typography>
                                  </Grid>
                              <Grid item xs={4}>
                                <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right', fontWeight: 'bold' }}>
                                      {this.state.application.paymentTerms} pv
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Slider
                                  value={this.state.application.paymentTerms}
                                  onChange={this.handlePaymentTermsChangeSlider}
                                  min={minPaymentTerms}
                                  max={maxPaymentTerms}
                                  step={paymentTermsStep}
                                />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Grid container alignItems="center" style={{ marginBottom: '8px' }}>
                              <Grid item xs={8}>
                                    <Typography className={classes.calculatorSliderText}>Rahoituslimiitti</Typography>
                                  </Grid>
                              <Grid item xs={4}>
                                <Typography className={classes.calculatorNumber} style={{ color: '#1961E1', textAlign: 'right', fontWeight: 'bold' }}>
                                  {this.state.application.fundingLimit.toLocaleString('fi')}&nbsp;€
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Slider
                                  value={this.state.application.fundingLimit}
                                  onChange={this.handleFundingLimitChangeSlider}
                                  min={minFundingLimit}
                                  max={maxFundingLimit}
                                  step={fundingLimitStep}
                                />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        {/* Professional Financial Contract Layout */}
                            <Box style={{ 
                          marginTop: '24px',
                          border: '2px solid #e0e0e0',
                          borderRadius: '8px',
                          backgroundColor: '#fafafa',
                          padding: '0'
                        }}>
                          {/* Header */}
                          <Box style={{ 
                            backgroundColor: '#f5f5f5',
                            padding: '16px 24px',
                            borderBottom: '1px solid #e0e0e0',
                            borderRadius: '6px 6px 0 0'
                          }}>
                            <Typography variant='h6' style={{ 
                              fontWeight: 'bold', 
                              color: '#333',
                              fontSize: '18px',
                              margin: 0
                            }}>
                              Laskurahoituksen ehdot ja kustannukset
                              </Typography>
                              <Typography variant='body2' style={{ 
                              color: '#666',
                              fontSize: '14px',
                              marginTop: '4px'
                            }}>
                              Yritykselle avattava rahoituslimiitti: {this.state.application.fundingLimit.toLocaleString('fi')}&nbsp;€ • Alustava tarjous perustuen antamiinne tietoihin
                              </Typography>
                          </Box>

                          {/* Financial Details Table */}
                          <Box style={{ padding: '0' }}>
                            {/* Immediate Funding Row */}
                            <Box style={{ 
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '16px 24px',
                              borderBottom: '1px solid #e0e0e0',
                              backgroundColor: 'white'
                            }}>
                              <Box>
                                <Typography variant='body1' style={{ 
                                  fontWeight: '600',
                                  color: '#333',
                                  fontSize: '14px'
                                }}>
                                  Välitön rahoitus
                                </Typography>
                                <Typography variant='body2' style={{ 
                                  color: '#666',
                                  fontSize: '12px', 
                                  marginTop: '2px'
                                }}>
                                  {this.state.calculatedResults.isLimitReached ? 'Limiitti rajoittaa summaa' : '90% laskujen arvosta maksetaan ennakkoon'}
                                </Typography>
                                <Typography variant='body2' style={{ 
                                  color: '#666',
                                  fontSize: '11px',
                                  marginTop: '4px',
                                  fontStyle: 'italic'
                                }}>
                                  Limiittiä vapautuu uudelleen käytettäväksi sitä mukaa, kun maksajat maksavat laskunsa Kasvurahoitukselle
                                </Typography>
                            </Box>
                              <Typography variant='h6' style={{ 
                                fontWeight: 'bold',
                                color: '#2c3e50',
                                fontSize: '18px',
                                whiteSpace: 'nowrap'
                              }}>
                                {this.state.calculatedResults.immediateFunding.toLocaleString('fi')}&nbsp;€
                              </Typography>
                            </Box>

                            {/* Final Settlement Row */}
                            <Box style={{ 
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '16px 24px',
                              borderBottom: '1px solid #e0e0e0',
                              backgroundColor: '#fafafa'
                            }}>
                              <Box>
                                <Typography variant='body1' style={{ 
                                  fontWeight: '600',
                                  color: '#333',
                                  fontSize: '14px'
                                }}>
                                  Lopputilitys eräpäivänä
                              </Typography>
                              <Typography variant='body2' style={{ 
                                  color: '#666',
                                fontSize: '12px', 
                                  marginTop: '2px'
                                }}>
                                  Asiakkaalle tilitettävä summa kun maksajat maksavat laskunsa
                                </Typography>
                                <Typography variant='body2' style={{ 
                                  color: '#666',
                                  fontSize: '11px',
                                  marginTop: '4px',
                                  fontStyle: 'italic'
                                }}>
                                  Välitön rahoitus + lopputilitys + rahoitusprovisio = rahoitettavien laskujen yhteissumma
                                </Typography>
                            </Box>
                              <Typography variant='h6' style={{ 
                                fontWeight: 'bold',
                                color: '#2c3e50',
                                fontSize: '18px'
                              }}>
                                {this.state.calculatedResults.reserve.toLocaleString('fi')}&nbsp;€
                              </Typography>
                            </Box>

                            {/* Monthly Cost Row */}
                            <Box style={{ 
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '16px 24px',
                              borderBottom: '1px solid #e0e0e0',
                              backgroundColor: 'white'
                            }}>
                              <Box>
                                <Typography variant='body1' style={{ 
                                  fontWeight: '600',
                                  color: '#333',
                                  fontSize: '14px'
                                }}>
                                  Kuukauden aikana keskimäärin maksetut rahoitusprovisiot
                              </Typography>
                              <Typography variant='body2' style={{ 
                                  color: '#666',
                                fontSize: '12px', 
                                  marginTop: '2px'
                                }}>
                                  Keskimäärin ~1,6% kuukaudessa
                                </Typography>
                                <Typography variant='body2' style={{ 
                                  color: '#666',
                                  fontSize: '11px',
                                  marginTop: '4px',
                                  fontStyle: 'italic'
                                }}>
                                  Kulut esitetty kuukausittain rahoitettavien laskujen perusteella
                                </Typography>
                            </Box>
                              <Typography variant='h6' style={{ 
                                fontWeight: 'bold',
                                color: '#2c3e50',
                                fontSize: '18px'
                              }}>
                                {this.state.calculatedResults.monthlyFactorFee.toLocaleString('fi')}&nbsp;€
                              </Typography>
                            </Box>

                            {/* Cash Flow Improvement Row */}
                            <Box style={{ 
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '16px 24px',
                              backgroundColor: '#fafafa'
                            }}>
                              <Box>
                                <Typography variant='body1' style={{ 
                                  fontWeight: '600',
                                  color: '#333',
                                  fontSize: '14px'
                                }}>
                                  Kassavirran parantuminen
                              </Typography>
                              <Typography variant='body2' style={{ 
                                  color: '#666',
                                fontSize: '12px', 
                                  marginTop: '2px'
                                }}>
                                  Saat rahat käyttöön {this.state.application.paymentTerms} päivää aiemmin
                                </Typography>
                                {this.state.calculatedResults.utilizationPercent > 0 && (
                                  <Typography variant='body2' style={{ 
                                    color: '#666',
                                    fontSize: '11px',
                                    marginTop: '4px',
                                    fontStyle: 'italic'
                                  }}>
                                    Rahoituslimiitin käyttöaste: {this.state.calculatedResults.utilizationPercent}%
                                  </Typography>
                                )}
                            </Box>
                              <Typography variant='h6' style={{ 
                                fontWeight: 'bold',
                                color: '#2c3e50',
                                fontSize: '18px'
                              }}>
                                +{this.state.application.paymentTerms} pv
                              </Typography>
                            </Box>
                          </Box>

                          {/* Footer with Terms */}
                          <Box style={{ 
                            backgroundColor: '#f5f5f5',
                            padding: '12px 24px',
                            borderTop: '1px solid #e0e0e0',
                            borderRadius: '0 0 6px 6px'
                          }}>
                            <Typography variant='body2' style={{ 
                              color: '#666',
                          fontSize: '12px', 
                          fontStyle: 'italic', 
                              textAlign: 'center'
                        }}>
                          * Lopulliset ehdot tarkentuvat riskiarviomme perusteella. Päivittäinen korko {this.state.calculatedResults.dailyRate}%.
                              Luottovakuutus sisältyy hintaan ilman lisäkuluja.
                        </Typography>
                          </Box>
                        </Box>
                      </Grid>

                      <Hidden xsDown >
                      <Grid item xs={12}>
                      <Typography variant='subtitle2' style={{ fontSize: "14px" }}>Jos olet jo asiakkaamme, voit kirjautua sivuillesi <a href="https://app.kasvurahoitus.fi/login">tästä</a>. Asiakaspalvelumme on tavoitettavissa puhelimitse numerossa +358 9 6829 8003 (ark. klo 9-16) ja sähköpostitse osoitteessa laskurahoitus@kasvurahoitus.fi.

                       
                       </Typography>
                        </Grid>
                        </Hidden>
                    </Grid>
                    

                  </Paper>


                </Grid>

                <Grid item md={4}>
                  <Paper elevation={3} style={{ padding: "32px", height: '100%', textAlign: 'left' }}>
                    <Typography variant='h3'>Laskurahoituksen avaaminen</Typography>
                    <Typography variant='subtitle2' style={{ margin: '12px 0 24px' }}>Täytä yrityksesi perustiedot laskurahoituksen avaamiseksi. Voit muuttaa rahoituksen tietoja vielä myöhemmin.</Typography>

                    <TextField
                      autoFocus
                      error={this.state.validation.BICError}
                      helperText={this.state.validation.BICError ? 'Y-tunnus puuttuu tai on virheellinen.' : ''}
                      placeholder="Laskurahoitusta hakevan yrityksen Y-tunnus"
                      variant="outlined"
                      fullWidth
                      value={this.state.application.bic}
                      onChange={this.handleChange('bic')}
                    />

                    <Collapse in={this.props.application.isPrhFetched}>
                      <Typography variant='subtitle2' style={{ fontWeight: '12px', margin: '4px 0' }}>Yrityksen tiedot saatiin noudettua Patentti- ja rekisterihallitukselta. </Typography>
                    </Collapse>

                    <TextField
                      id="companyName"
                      fullWidth
                      error={this.state.validation.companyNameError}
                      placeholder="Yrityksen nimi"
                      variant="outlined"
                      value={this.state.application.companyName}
                      onChange={this.handleChange('companyName')}
                    />

                    <TextField
                      error={this.state.validation.emailError}
                      placeholder="Yhteyshenkilön sähköpostiosoite"
                      variant="outlined"
                      fullWidth
                      value={this.state.application.email}
                      onChange={this.handleChange('email')}
                    />

                    <TextField
                      fullWidth
                      error={this.state.validation.phoneError}
                      placeholder="Yhteyshenkilön puhelin"
                      variant="outlined"
                      value={this.state.application.phone}
                      onChange={this.handleChange('phone')}
                    />

                    
                    <TextField
                      fullWidth                      
                      placeholder="Kampanjakoodi"
                      variant="outlined"
                      value={this.state.application.discountCode}
                      onChange={this.handleChange('discountCode')}
                    />

                    <Box style={{ marginTop: "16px", background: '#fff', border: '1px solid #EBEBEA', textAlign: "left" }}>
                      <Grid container alignItems='center' style={{ padding: '8px 16px 16px' }}>
                        <Grid item xs={10}>
                          <Typography variant='subtitle2' style={{ fontSize: "12px" }}>
                            Hyväksyn, että luottopäätös tehdään automatisoidusti tekoälyn avulla. Ymmärrän, että minulla on oikeus pyytää ihmisen tekemää arviointia ja vastustaa automatisoidun päätöksenteon käyttöä.
                          </Typography>
                          {this.state.aiConsentRequired === true && <Typography variant='subtitle2' style={{ color: "red" }}><br />Sinun tulee hyväksyä automatisoidun päätöksenteon käyttö jatkaaksesi</Typography>}
                        </Grid>
                        <Grid item xs={2} style={{ textAlign: 'center' }}>
                          <Box>
                            <Switch color="primary" checked={this.state.aiDecisionConsent} onChange={this.handleAiDecisionConsentClick} name="aiConsent" />
                          </Box>
                          <Typography variant='subtitle2' style={{ marginTop: '-6px' }}>
                            {this.state.aiDecisionConsent ? 'Kyllä' : 'Ei'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    <Box style={{ marginTop: "16px", background: '#fff', border: '1px solid #EBEBEA', textAlign: "left" }}>
                      <Grid container alignItems='center' style={{ padding: '8px 16px 16px' }}>
                        <Grid item xs={10}>
                          <Typography variant='subtitle2' style={{ fontSize: "12px" }}>
                            Olen tutustunut Kasvurahoituksen <a target="_blank" title="Kasvurahoitus yrityslaina käyttöehdot" href="https://www.kasvurahoitus.fi/front-kasvurahoitus-kaeyttoeehdot/">käyttöehtoihin</a> ja hyväksyn ne itseäni ja edustamaani yritystä sitoviksi.
                          Annan suostumuksen henkilötietojeni käyttämiseen luottokelpoisuuden arviointiin luottotietorekisteristä tehtäviin kyselyihin sekä muista saatavilla olevista tietolähteistä.
                          </Typography>
                          {this.state.defaultRequired === true && <Typography variant='subtitle2' style={{ color: "red" }}><br />Sinun tulee hyväksyä käyttöehtomme jatkaaksesi</Typography>}
                        </Grid>

                        <Grid item xs={2} style={{ textAlign: 'center' }}>
                          <Box>
                            <Switch color="primary" checked={this.state.defaultCheck} onChange={this.handleDefaultCheckClick} name="checkedC" />
                          </Box>
                          <Typography variant='subtitle2' style={{ marginTop: '-6px' }}>
                            {this.state.defaultCheck ? 'Kyllä' : 'Ei'}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>

                    <div style={{width: "100%", textAlign: "center"}}>


                    <Button
                      style={{ marginTop: '24px' }}
                      color="primary"
                      variant="contained"
                      endIcon={<React.Fragment>→</React.Fragment>}
                      size='large'
                      onClick={() => { this.validateFirstView() }}
                    >
                      {activeStep === steps.length - 1 ? 'Finish' : 'Avaa laskurahoitus'}
                    </Button>
                    <Hidden xsDown >
                      <div style={{marginTop: "32px", textAlign: "center", width: "100%", minHeight: "120px"}}>
                        <div className="trustpilot-widget" data-locale="en-US" data-template-id="53aa8807dec7e10d38f59f32" 
                          data-businessunit-id="607582d37881d800016abf4e" data-style-height="150px" data-style-width="100%" 
                          data-token="b01ad698-a42b-4c0a-99a2-2cf6b427beb5"
                          style={{minHeight: "150px", width: "100%", marginBottom: "20px", display: "block"}}>
                          <a href="https://www.trustpilot.com/review/kasvurahoitus.fi" target="_blank" rel="noopener">Trustpilot</a>
                        </div>

                      </div>
                    </Hidden>
                      </div>

                  </Paper>
                </Grid>

              </Grid>
            </Grid>
          }

          {activeStep === 99 && <Grid item xs={12}><Paper elevation={3} style={{padding: '32px'}}>

            <div className="marginTop20" style={{ textAlign: "left" }}>
              <div className="applyForm">
                <div className="container">
                  <h1 style={{ textAlign: "center" }}>Salasana yritysportaaliin</h1>

                  <div className="applyLoanInfo2 applyForm applicationConditions">

                    <div className="row">

                      <div className="col-md-6 applyInputInfo">
                        <p>
                          Aseta salasana, jota käytät kirjautuessasi palveluun tunnuksella {this.state.application.email}</p>
                      </div>
                      <div className="col-md-1">
                        <img src="/img/icon_key.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>

                      <div className="col-md-5"> {/* content for pwd validation */}
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="marginTop20" />

                            <TextField
                              error={this.state.validation.passwordError}
                              label="Salasana"
                              fullWidth={true}
                              type="password"
                              value={this.state.application.password}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('password')} />

                            {this.state.validation.phoneError === true &&
                              <div>
                                <p>Salasanan muoto on virheellinen.</p>
                              </div>}
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="marginTop20" />
                            <TextField
                              error={this.state.validation.passwordAgainError}
                              label="Salasana uudestaan"
                              fullWidth={true}
                              type="password"
                              value={this.state.application.passwordAgain}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('passwordAgain')} />

                            {this.state.validation.passwordAgainError === true &&
                              <div>
                                <p>Salasanojen tulee täsmätä</p>
                              </div>}
                          </div>
                        </div>
                        {/* eof content for pwd validation */}
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div className="applyForm" style={{ textAlign: "left" }}>
              <div className="container">
                <h1 style={{ textAlign: "center" }}>Hakijan tiedot</h1>
                <div className="row">
                  <div className="col-md-2">
                    <img src="/img/icon_travelbook.png" style={{ width: "100px" }} />
                  </div>
                  <div className="col-md-10">

                    <div className="marginTop20"> <h1>Käyttäjätunnuksen valinta</h1> </div>
                    <div className="row">
                      <div className="col-md-6 applyInputInfo"> <p>
                        {/* <IconLock style={iconStyle}/> */} Sähköpostiosoitteesi toimii samalla käyttäjätunnuksena palveluun </p> </div>
                      <div className="col-md-1">
                        <img src="/img/icon_envelope.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>

                      <div className="col-md-5">

                        {this.props.application.isEmailValidationRequested === true && this.props.application.isEmailValidated === false &&
                          <div className="row">
                            <div className="col-12 col-md-12 applyLoanHighlight" style={{ marginTop: "20px" }}>
                              <Snack message={"Vahvistuskoodi lähetetty sähköpostiin " + this.state.application.email} />
                              <p>Lähetimme vahvistuskoodin sähköpostiisi. Ole hyvä ja syötä koodi allaolevaan kenttään. </p>
                              <div className="row">
                                <div className="col-11 col-md-11">
                                  <TextField id="emailCode"
                                    fullWidth={true}
                                    label="Tunniste"
                                    InputLabelProps={{}}
                                    value={this.state.emailCode}
                                    onChange={this.handleChange('emailCode')}
                                  />
                                </div>
                                <div className="col-1 col-md-1">
                                  {this.state.validation.BICError === false && <div> <IconOk style={okStyle} /> </div>}
                                  {this.state.validation.BICError === true && <div> <IconError style={errorStyle} /> </div>}
                                </div>
                              </div>

                              <p style={{ marginTop: "20px" }}>Etkö saanut vahvistusviestiä sähköpostiisi? Huomaathan, että viestin saapumiseen voi mennä jopa useita minuutteja. </p>
                              <Button>Lähetä uusi vahvistuskoodi</Button>
                            </div>
                          </div>
                        }

                        {this.props.application.isEmailValidationCodeRequested === true && <div style={{ textAlign: "center" }}> <CircularProgress /> </div>}
                        {this.props.application.isEmailValidationRequested === true && this.props.application.isEmailValidated === true && <div> Sähköpostiosoite <i>{this.state.application.email}</i> on vahvistettu onnistuneesti  <IconOk style={okStyle} /> </div>}

                      </div>
                    </div>
                    {/*
    {(this.props.application.isEmailValidated === true || this.props.application.isEmailValidated === false) && 
    <div className="applyLoanHighlight">
    */}

                    <div className="marginTop20">
                      <h1>Matkapuhelinnumero</h1>
                    </div>

                    <div className="row">
                      <div className="col-md-6 applyInputInfo">
                        <p>
                          Numerosta saamme tarvittaessa yhteyden hakemukseen liittyvissä asioissa </p>
                      </div>
                      <div className="col-md-1">
                        <img src="/img/icon_phone2.png" style={{ width: "23px", marginTop: "10px" }} />
                      </div>
                      <div className="col-md-5">
                        {/* content for mobile validation */}

                        <div className="row">
                          <div className="col-11 col-md-11">
                            <div className="marginTop20" />

                            <TextField
                              error={this.state.validation.phoneError}
                              label="Matkapuhelinnumero"
                              fullWidth={true}
                              value={this.state.application.phone}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.handleChange('phone')} />
                            {/* this.state.validation.phoneError === true && <div> <p>Matkapuhelimen numeron muoto on virheellinen.</p> </div> */}
                          </div>
                          <div className="col-1 col-md-1">
                            {this.state.validation.phoneError === false && <div> <IconOk style={okStyle} /> </div>}
                            {this.state.validation.phoneError === true && <div> <IconError style={errorStyle} /> </div>}
                          </div>
                        </div>
                        {this.props.application.isPhoneValidationCodeRequested === true && <div style={{ textAlign: "center" }}> <CircularProgress /> </div>}
                        {this.props.application.isPhoneValidated === true && <div> <p>Olet vahvistanut numeron <i>{this.state.application.phone}</i> onnistuneesti <IconOk style={okStyle} /></p> </div>}

    {/* do not use Mobile validation for conversion reasons
        {this.state.validation.phoneError === false && this.props.application.isPhoneValidated === false &&
          <div className="row">
            <div className="col-12 col-md-12" style={{marginTop: "10px"}}>    
            <p>Lähetämme matkapuhelimeen vahvistustunnuksen, jolla vahvistat liittymän hallinnan.</p>   
              <Button raised color="primary"  onClick={() => {this.validatePhoneClick()}}>Lähetä vahvistusviesti</Button>  
            </div>
          </div>
        }
      */}

                        {this.props.application.isPhoneValidationRequested === true && this.props.application.isPhoneValidated === false &&
                          <div className="row">
                            <div className="col-12 col-md-12 applyLoanHighlight" style={{ marginTop: "20px" }}>
                              <Snack message={"Vahvistuskoodi lähetetty matkapuhelimeen " + this.state.application.phone} />
                              <p>Lähetimme vahvistuskoodin puhelimeesi. Ole hyvä ja syötä koodi allaolevaan kenttään. </p>
                              <div className="row">
                                <div className="col-11 col-md-11">
                                  <TextField id="phoneCode"

                                    fullWidth={true}
                                    label="Tunniste"
                                    InputLabelProps={{

                                    }}
                                    value={this.state.phoneCode}
                                    onChange={this.handleChange('phoneCode')}
                                  />
                                </div>
                              </div>
                              {/* <p style={{marginTop: "20px"}}>Etkö saanut vahvistusviestiä matkapuhelimeesi? Huomaathan, että viestin saapumiseen voi mennä jopa useita minuutteja. </p><Button>Lähetä uusi</Button> */}

                            </div>
                          </div>
                        }
                        {/* eof content for mobile validation */}
                      </div>
                    </div>
                    {/*password set*/}
                    <div className="marginTop20">
                      <h1>Salasana palveluun</h1>
                    </div>


                    {/*end of password set */}
                  </div>
                </div>
              </div>
            </div>
            </Paper>
          </Grid>
          }

          {activeStep === 1 &&

            <Grid item xs={12}>
              <Paper elevation={3} style={{ padding: "32px", textAlign: 'left' }}>
                <Typography variant='h3' style={{ marginBottom: '24px' }}>Lisätiedot ja liitteet</Typography>

                <Typography variant='body1' style={{ marginBottom: '24px', lineHeight: '1.6' }}>
                  Kerro meille hieman lisätietoja, jotta voimme tarjota sinulle parhaan mahdollisen palvelun. 
                  Voit myös liittää hakemukseen tukidokumentteja päätöksenteon tueksi.
                </Typography>

                {/* What happens next section */}
                <Box style={{ 
                  backgroundColor: '#f8f9fa', 
                  padding: '20px', 
                  borderRadius: '8px', 
                  marginBottom: '32px',
                  border: '1px solid #e9ecef'
                }}>
                  <Typography variant='h6' style={{ 
                    marginBottom: '12px', 
                    color: '#333',
                    fontWeight: 'bold'
                  }}>
                    Mitä tapahtuu seuraavaksi?
                  </Typography>
                  <Typography variant='body2' style={{ 
                    lineHeight: '1.6',
                    color: '#555'
                  }}>
                    Tunnistautumisen jälkeen käsittelemme avauspyyntösi. Mikäli hakemuksen tiedot ovat kunnossa ja haettu rahoituslimiitti on linjassa yrityksen toiminnan kanssa, saat yritykselle räätälöidyn rahoitussopimuksen allekirjoitettavaksi välittömästi Visma Sign -palveluun. Allekirjoitettuasi palvelusopimuksen, Kasvurahoituksen laskurahoituspalvelu on yrityksesi käytössä.
                  </Typography>
                </Box>

                {this.state.isSavingAfterStep1 && (
                  <Box style={{ textAlign: 'center', margin: '20px 0' }}>
                    <CircularProgress />
                    <Typography variant='body2' style={{ marginTop: '10px' }}>
                      Tallennetaan hakemustasi...
                    </Typography>
                  </Box>
                )}

                {/* Billing System Selection */}
                <Box style={{ marginTop: '32px', marginBottom: '32px' }}>
                  <Typography variant='h5' style={{ marginBottom: '16px' }}>
                    Laskutusjärjestelmä
                  </Typography>
                  <Typography variant='body2' style={{ marginBottom: '16px' }}>
                    Kerro meille mitä laskutusjärjestelmää käytät, jotta voimme ohjeistaa kirjanpidon käytännöt ja mahdolliset laskutusasetukset oikein.
                  </Typography>
                  
                  <FormControl variant="outlined" fullWidth style={{ marginBottom: '16px' }}>
                    <MuiInputLabel>Valitse laskutusjärjestelmä</MuiInputLabel>
                    <Select
                      value={this.state.application.factoringSourceEnum}
                      onChange={this.handleFactoringSourceChange}
                      label="Valitse laskutusjärjestelmä"
                    >
                      <MenuItem value={0}>En tiedä tai en ole varma</MenuItem>
                      <MenuItem value={1}>Netvisor</MenuItem>
                      <MenuItem value={2}>Procountor</MenuItem>
                      <MenuItem value={3}>Fennoa</MenuItem>
                      <MenuItem value={4}>Askelma</MenuItem>
                      <MenuItem value={5}>Invoicer</MenuItem>
                    </Select>
                  </FormControl>

                  {this.state.application.factoringSourceEnum === 0 && (
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Kuvaile laskutusjärjestelmääsi"
                      placeholder="Esim. Excel, oma järjestelmä, muu ohjelma..."
                      value={this.state.application.factoringSourceDescription}
                      onChange={this.handleFactoringSourceDescriptionChange}
                      multiline
                      rows={3}
                      style={{ marginBottom: '16px' }}
                    />
                  )}
                </Box>

                <OptionalAttachments 
                  onAttachmentsChange={this.handleAttachmentsChange} 
                  loanType={5}
                />
                {this.props.application.isFetching === true &&
                  <Box style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </Box>
                }
                {this.props.application.isFetching === false && <Box style={{ textAlign: 'center', display:'flex', paddingTop:'15px' }}>

                  <Button
                    className="applyContinueBtn"
                    color="primary"
                    variant="contained"
                    size='large'
                    onClick={this.authenticate}
                    disabled={this.state.isUploading}
                  >
                    {this.state.isUploading 
                      ? (this.state.attachments.length > 0 
                          ? `Lähetetään ${this.state.attachments.length} tiedosto(a)...`
                          : 'Tallennetaan hakemusta...'
                        )
                      : 'Viimeistele hakemus tunnistautumalla'
                    }
                    </Button>

                </Box>}
                {this.props.authentication.isAuthenticated === true && <Box style={{ textAlign: 'center' }}>
                  Hetu: {this.props.authentication.ssn}
                </Box>}
              </Paper>
            </Grid>

          }
          {activeStep === 4 &&

            <Grid item xs={12}>
              <Paper elevation={3} className="applyForm" style={{ padding: "32px", textAlign: "left" }}>

                {this.props.application.isFetching === false &&
                  <Snack message={"Tunnistautuminen onnistui " + this.props.application.firstName + " " + this.props.application.lastName + " (" + this.props.application.ssn + ")"} />
                }
                {this.props.application.isFetching === true &&
                  <Box style={{ textAlign: "center" }}>
                    <CircularProgress />
                  </Box>}
                {this.props.application.isFetching === false && <Box>
                  <Typography variant='h3' style={{ marginBottom: '16px' }}>Laskurahoitushakemuksesi on rekisteröity ja otettu käsittelyyn</Typography>

                  <Typography variant='body2'>Olemme yhteydessä yhden arkipäivän kuluessa mahdollisissa hakemuksen käsittelyyn liityvissä kysymyksissä. </Typography>

                  {this.state.activeStep === 4 &&
                    <ApplicationDetails />
                  }
                </Box>}


              </Paper>
            </Grid>

          }

          {/* Begin of Back / Forward buttons */}
          {(activeStep === steps.length || activeStep === 0) ? (
            <Box></Box>
          ) : (
              <Grid item xs={12}>
                <Typography >{getStepContent(activeStep)}</Typography>
                <Box style={{ textAlign: "right" }}>

                  <Button
                    disabled={activeStep === 0}
                    onClick={this.handleBack}
                    variant='contained'
                    color='secondary'
                    size='large'
                  >
                    Edellinen
                    </Button>

                  {this.isStepOptional(activeStep) && (
                    <Button
                      variant="contained"
                      color="secondary"
                      size='large'
                      onClick={this.handleSkip}
                    >
                      Skip
                    </Button>
                  )}

                  {(
                    (this.state.activeStep === 2 && this.state.validation.emailError === false
                      && (this.props.application.isPhoneValidated === true || this.state.validation.phoneError === false)
                      && this.state.application.password !== undefined
                      && this.state.application.passwordAgain !== undefined
                      && this.state.validation.passwordAgainError === false)

                    || (this.state.activeStep === 1 && (this.state.application.isPrhFetched === true || this.state.application.bic !== "") && this.state.defaultCheck === true && this.state.terms === true && this.state.aiDecisionConsent === true)
                  ) &&
                    <Button
                      style={{ marginLeft: "10px" }}
                      color="primary"
                      variant="contained"
                      size='large'
                      onClick={() => { this.handleNext() }}
                      disabled={this.state.isSavingAfterStep1}
                    >
                      {this.state.isSavingAfterStep1 
                        ? 'Tallennetaan...'
                        : (activeStep === steps.length - 1 ? 'Finish' : 'Seuraava')
                      }
                    </Button>
                  }
                </Box>
              </Grid>
            )}
          {/* End of Back / Forward buttons */}

        </Grid>

      </Box>
    )
  }

}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)(InvoiceFinancingProcess);
